import { render, staticRenderFns } from "./InfosCampanhaForm.vue?vue&type=template&id=bb072340&"
import script from "./InfosCampanhaForm.vue?vue&type=script&lang=js&"
export * from "./InfosCampanhaForm.vue?vue&type=script&lang=js&"
import style0 from "./InfosCampanhaForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports